import { render, staticRenderFns } from "./SearchOverlay.vue?vue&type=template&id=1237d3ba&scoped=true"
import script from "./SearchOverlay.vue?vue&type=script&lang=js"
export * from "./SearchOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237d3ba",
  null
  
)

export default component.exports